import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCadance = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_86",
		"data-name": "Group 86",
		transform: "translate(0.146 0.464)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_85",
				"data-name": "Group 85",
				transform: "translate(11.484 3.081)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Path_2152",
					"data-name": "Path 2152",
					transform: "translate(0 12.034)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_208",
						"data-name": "Path 208",
						d: "M167.982,268.7c-2.491,0-3.017-3.125-3.275-4.664-.046-.276-.088-.524-.132-.726-.059-.26-.2-.7-.349-1.167a14.431,14.431,0,0,1-.873-3.88,6.489,6.489,0,0,1,1.779-4.716,3.61,3.61,0,0,1,2.784-.992c2.2.159,3.352,2.535,3.352,4.8a8.541,8.541,0,0,1-.444,2.6,4.708,4.708,0,0,0-.273,1.355,12.6,12.6,0,0,0,.179,1.631c.242,1.627.517,3.472-.42,4.7a2.749,2.749,0,0,1-1.95,1.04A3.25,3.25,0,0,1,167.982,268.7Zm-.346-14.043a1.515,1.515,0,0,0-1.067.438,4.511,4.511,0,0,0-1.106,3.17,13.555,13.555,0,0,0,.772,3.236c.171.535.32,1,.4,1.349.053.233.1.52.155.838.3,1.8.631,2.98,1.325,2.895h0c.38-.044.48-.177.518-.227.394-.514.172-2.01.009-3.1a13.829,13.829,0,0,1-.2-1.942,6.561,6.561,0,0,1,.361-1.958,6.47,6.47,0,0,0,.356-2c0-1.247-.532-2.632-1.393-2.694Q167.7,254.66,167.636,254.66Z",
						transform: "translate(-163.352 -252.549)",
						fill: "#101820"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Path_2153",
					"data-name": "Path 2153",
					transform: "translate(10.45 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_209",
						"data-name": "Path 209",
						d: "M186.436,245.9a3.344,3.344,0,0,1-.377-.022h0a2.745,2.745,0,0,1-1.949-1.041c-.937-1.224-.663-3.069-.421-4.7a12.515,12.515,0,0,0,.179-1.631,4.708,4.708,0,0,0-.273-1.355,8.538,8.538,0,0,1-.445-2.6c0-2.264,1.152-4.64,3.353-4.8a3.61,3.61,0,0,1,2.783.993,6.485,6.485,0,0,1,1.779,4.715,14.44,14.44,0,0,1-.872,3.878c-.149.467-.291.908-.348,1.168-.046.2-.087.452-.134.728C189.452,242.78,188.926,245.9,186.436,245.9Zm-.131-2.119c.675.082,1.023-1.1,1.325-2.894.053-.318.1-.606.155-.839.078-.352.226-.814.4-1.35a13.51,13.51,0,0,0,.772-3.234,4.511,4.511,0,0,0-1.1-3.169,1.518,1.518,0,0,0-1.193-.433c-.861.063-1.394,1.447-1.394,2.694a6.458,6.458,0,0,0,.357,2,6.56,6.56,0,0,1,.361,1.958,13.888,13.888,0,0,1-.2,1.941c-.163,1.093-.386,2.589.008,3.1.039.05.14.182.519.226Z",
						transform: "translate(-183.15 -229.749)",
						fill: "#101820"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_22",
				"data-name": "Rectangle 22",
				width: 34,
				height: 34,
				transform: "translate(-0.146 -0.464)",
				fill: "none"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_210",
				"data-name": "Path 210",
				d: "M152.416,245.461l-2.81-2.81a1.048,1.048,0,0,0-.162-.132c-.025-.017-.052-.029-.079-.043s-.067-.039-.1-.054a1.057,1.057,0,0,0-.106-.033c-.031-.009-.06-.021-.091-.027a1.048,1.048,0,0,0-.413,0c-.032.006-.061.018-.092.027a1.043,1.043,0,0,0-.105.033c-.036.015-.069.036-.1.054s-.053.026-.079.043a1.023,1.023,0,0,0-.162.132l-2.811,2.81a1.056,1.056,0,1,0,1.493,1.493l1.009-1.01V256.6a1.056,1.056,0,0,0,2.111,0V245.944l1.009,1.01a1.056,1.056,0,1,0,1.493-1.493Z",
				transform: "translate(-143.199 -232.613)",
				fill: "#101820"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgCadance);
export { ForwardRef as ReactComponent };
